export const EVENT_NAME = {
  SEEN: "seen"
};
